import { z } from 'zod'

import { Locale, LOCALES } from '../commonFormatters'

export type Localized<T> = { hu: T; en?: T }

export const localized = <T extends z.ZodTypeAny>(schema: T) =>
    z.object({ hu: schema, en: schema.optional() })

export const cmsLocaleSchema = z.enum(LOCALES)

/**
 * Resolution is `||`, never `??`. An editor who creates the English row and leaves a field blank
 * must fall back to Hungarian; with `??` the empty string wins and English visitors get a blank.
 *
 * `localizeTranslationValue` is deliberately not reused here: its last resort is "the first
 * non-empty value of any key", which would surface an untranslated locale's text as if it were a
 * translation.
 */
export const resolveLocalized = (value: Localized<string>, locale: Locale): string =>
    // `value.hu` rather than `value[DEFAULT_LOCALE]`: the required key of `Localized` is what
    // makes the fallback total, and indexing by the widened `Locale` type loses that.
    value[locale] || value.hu

export const cmsLocales: readonly Locale[] = LOCALES
